import React from 'react';
import aboutImage from '../../assets/images/About.jpg';

const About = () => {
  return (
    <section id="about" className="about">
      <div className="container">
        <h2 className="section-title">About Us</h2>
        <div className="about-content">
          <div className="about-text">
            <h3>Creating Timeless Memories</h3>
            <p>With over 10 years of experience in photography, we specialize in capturing the most precious moments of your life. From intimate weddings to grand celebrations, we bring creativity, passion, and technical expertise to every shoot.</p>
            <p>Our team of professional photographers understands the importance of your special day and works tirelessly to ensure every emotion, every smile, and every tear is beautifully preserved for generations to come.</p>
            <div className="about-stats">
              <div className="stat">
                <h4>500+</h4>
                <p>Happy Clients</p>
              </div>
              <div className="stat">
                <h4>1000+</h4>
                <p>Events Covered</p>
              </div>
              <div className="stat">
                <h4>50K+</h4>
                <p>Photos Captured</p>
              </div>
            </div>
          </div>
          <div className="about-image">
            <img src={aboutImage} alt="About us" />
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
